import { useCurrentMode } from '@app/styled';

const useIsDarkMode = () => useCurrentMode() === 'dark';

export default useIsDarkMode;
